'use es6';

import { useSelector } from 'react-redux';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
export const withSessionId = WrappedComponent => props => {
  const sessionId = useSelector(getSessionId);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    sessionId: sessionId
  }));
};